import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
import { Button } from './ui/button';
import { useTranslation } from 'react-i18next';

const Hero = () => {
  const { t } = useTranslation();
  
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center pt-20 pb-16 overflow-hidden">
      {/* Background video with overlay */}
      <div className="absolute inset-0 z-0">
        <video
          src="https://customer-assets.emergentagent.com/job_navarra-supply/artifacts/qbddh3qd_WhatsApp%20Video%202026-03-27%20at%2018.13.25.mp4"
          className="w-full h-full object-cover"
          autoPlay
          muted
          loop
          playsInline
        >
          Tu navegador no soporta la reproducción de videos.
        </video>
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-transparent"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-4xl">
          <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold text-white mb-6 md:mb-8 leading-tight tracking-tight">
            {t('hero.title')}
          </h1>
          
          <p className="text-lg md:text-xl lg:text-2xl text-gray-100 mb-8 md:mb-10 leading-relaxed font-light max-w-3xl">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 mb-8 md:mb-12">
            <Button
              onClick={scrollToContact}
              size="lg"
              className="bg-cmv-green hover:bg-cmv-green-dark text-white text-base md:text-lg px-6 md:px-8 py-5 md:py-6 group w-full sm:w-auto">

              {t('hero.cta')}
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" size={18} />
            </Button>
            <Button
              onClick={() => window.location.href = 'tel:+34948670255'}
              size="lg"
              variant="outline"
              className="border-2 border-white text-white hover:bg-white hover:text-cmv-green text-base md:text-lg px-6 md:px-8 py-5 md:py-6 backdrop-blur-sm w-full sm:w-auto">

              <Phone className="mr-2" size={18} />
              <span className="text-sm md:text-base">{t('hero.phone')}</span>
            </Button>
          </div>

          {/* Stats */}
          <div className="grid grid-cols-3 gap-4 md:gap-8 pt-6 md:pt-8 border-t border-white/30">
            <div>
              <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">+30</div>
              <div className="text-gray-300 text-xs md:text-sm">{t('hero.stats.experience')}</div>
            </div>
            <div>
              <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">+60.000</div>
              <div className="text-gray-300 text-xs md:text-sm">{t('hero.stats.deliveries')}</div>
            </div>
            <div>
              <div className="text-2xl md:text-4xl font-bold text-white mb-1 md:mb-2">100%</div>
              <div className="text-gray-300 text-xs md:text-sm">{t('hero.stats.quality')}</div>
            </div>
          </div>
        </div>
      </div>
    </section>);

};

export default Hero;